export enum BookingStatusTabs {
    pending = 'pending',
    upcoming = 'upcoming',
    ongoing = 'ongoing',
    history = 'history'
}
export enum BookingStatus {
    CONFIRMED_QUICK = 1,
    CONFIRMED_BY_HOST = 2,
    CONFIRMED_BY_SYSTEM = 3,
    CANCELLED_BY_HOST = 4,
    CANCELLED_BY_USER = 5,
    CANCELLED_BY_SYSTEM = 6,
    PENDING_CONFIRMATION_BY_HOST = 7,
    PENDING_CAPTURE_MONEY = 8,
    COMPLETED = 9,
    EXPIRED = 10,
    FAILED = 11,
    // Set by the host or an admin when the guest did not turn up.
    NO_SHOW = 12
}

export enum ConfirmBookingStatus {
    UPCOMING = 'UPCOMING',
    ONGOING = 'ONGOING',
    NOSHOW = 'NOSHOW',
    COMPLETED = 'COMPLETED',
    EXPIRED = 'EXPIRED',
    FAILED = 'FAILED',
    PENDING = 'PENDING',
    CANCELLED = 'CANCELLED'
}

export const BookingStatusArray: Record<string, number[]> = {
        pending: [BookingStatus.PENDING_CONFIRMATION_BY_HOST],
        upcoming: [
            BookingStatus.CONFIRMED_QUICK,
            BookingStatus.CONFIRMED_BY_HOST,
            BookingStatus.CONFIRMED_BY_SYSTEM,
            BookingStatus.PENDING_CAPTURE_MONEY
        ],
        ongoing: [
            BookingStatus.CONFIRMED_QUICK,
            BookingStatus.CONFIRMED_BY_HOST,
            BookingStatus.CONFIRMED_BY_SYSTEM,
            BookingStatus.PENDING_CAPTURE_MONEY,
            BookingStatus.NO_SHOW
        ],
        history: [
            BookingStatus.CONFIRMED_QUICK,
            BookingStatus.CONFIRMED_BY_HOST,
            BookingStatus.CONFIRMED_BY_SYSTEM,
            BookingStatus.PENDING_CAPTURE_MONEY,
            BookingStatus.COMPLETED,
            BookingStatus.EXPIRED,
            BookingStatus.CANCELLED_BY_USER,
            BookingStatus.CANCELLED_BY_HOST,
            BookingStatus.CANCELLED_BY_SYSTEM,
            BookingStatus.NO_SHOW
        ]
    };
